import React, { useCallback } from 'react';
import { useObserverReturningStore } from '../../../CodesThatsGottaGoSomewhereElse';
import { LFC } from '../../../Legacy';
import { CommandDispatcher } from '../../../concepts/commands/CommandDispatcher';
import { Icon } from '../../../concepts/resources/Icon';
import { useResolve } from '../../Container';
import { Shortcut } from '../../Shortcut';
import { FixMenuWrap } from '../../canvas/participants/FixMenuWrap';
import { toolEquip } from '../../canvas/tooling/ToolCommands';
import { ToolManager } from '../../canvas/tooling/ToolManager';
import { PopoutWidget } from '../../canvas/workspace/widgets/WidgetInterface';
import { Flexer } from '../../dashboard/elements/LayoutElements';
import { userThrowHat } from '../hats/HatsCommands';
import { Menu } from './../../../ui';

export const GesturesWidget: LFC<{ widget: PopoutWidget }> = ({ widget }) => {

    const tools = useObserverReturningStore(useResolve(ToolManager));
    const dispatch = useResolve(CommandDispatcher);
    const onSelect = useCallback((toolId: string) => {
        widget.update({ open: false });
        dispatch(toolEquip, [toolId]);
    }, []);

    const onThrowHat = () => {
        widget.update({ open: false });
        dispatch(userThrowHat);
    };

    return <Flexer >
        <FixMenuWrap>
            <Menu>
                <Menu.Item disabled={!tools.isEnabled('pingTool')} onClick={() => onSelect('pingTool')}>
                    <Icon size="1.2" src="deqo://icons/hero/arrow-down" />
                    Ping
                    <Menu.Shortcut keys="1" />
                    <Shortcut keys="1" target={() => onSelect('pingTool')} />
                </Menu.Item>
                <Menu.Item disabled={!tools.isEnabled('annotateTool')} onClick={() => onSelect('annotateTool')}>
                    <Icon size="1.2" src="deqo://icons/hero/pencil-alt" />
                    Vanishing Pen
                    <Menu.Shortcut keys="2" />
                    <Shortcut keys="2" target={() => onSelect('annotateTool')} />
                </Menu.Item>
                <Menu.Item disabled={!tools.isEnabled('confettiTool')} onClick={() => onSelect('confettiTool')}>
                    <Icon size="1.2" src="deqo://icons/d2/confetti" />
                    Confetti
                    <Menu.Shortcut keys="3" />
                    <Shortcut keys="3" target={() => onSelect('confettiTool')} />
                </Menu.Item>
                <Menu.Item disabled={!tools.isEnabled('throwHatTool')} onClick={onThrowHat}>
                    <Icon size="1.2" src="deqo://icons/i8/hat" />
                    Throw Hat
                    <Menu.Shortcut keys="4" />
                    <Shortcut keys="4" target={onThrowHat} />
                </Menu.Item>
            </Menu>
        </FixMenuWrap>
    </Flexer>;
};
